/** 通用占位页：S04 只保证导航通，内容在后续 Step 替换。 */

import { Typography } from "antd";

export function PlaceholderPage({ title, hint }: { title: string; hint?: string }) {
  return (
    <div style={{ padding: 48, textAlign: "center" }}>
      <Typography.Title level={3}>{title}</Typography.Title>
      <Typography.Paragraph type="secondary">
        {hint ?? "本模块将在后续 Step 中实现（见 docs/wiki/wiki.md）"}
      </Typography.Paragraph>
    </div>
  );
}
